export enum ChangeEvent {
  Change = "change"
};

export interface TranscriptionEvent extends Event {
  payload: any;
}
